import React from "react";

export default function Footer() {
  return (
    <small className="coded">
      <a
        href="https://github.com/laura-dumitru/weather-react"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open source code {""}
      </a>
      by {""}{" "}
      <a
        href="https://github.com/laura-dumitru"
        target="_blank"
        rel="noopener noreferrer"
      >
        Laura Dumitru
      </a>
    </small>
  );
}
